import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './license-activation.hbs'
import FormView from 'scoreboard/components/form-view'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import MarkedField from 'scoreboard/components/marked-field'
import LicenseForm from './license-form'
import globals from 'scoreboard/components/globals'
import constants from 'scoreboard/components/constants'
import licenses from 'scoreboard/components/licenses'
import appDisplay from 'scoreboard/components/app-display'

var LicenseActivation = Backbone.View.extend({

	// this.license is the license

	tagName: 'form',

	className: 'license-activation',

	initialize: function(options) {
		this.options = options || {}
		this.license = this.options.license
		this.formView = new FormView({ el: this.el, submit: this.submit.bind(this) })
	},

	render: function() {
		this.$el.empty().append(template(this.license))
		this.answerField = new MarkedField({
			el: this.$('[name=answerKey]'),
			validator: requiredValidator
		}).render()
		this.formView.start()
		return this
	},

	submit: function() {
		var url = 'api/admin/licenses/' + this.license.id + '/activate'
		return $.ajax({
			method: 'post',
			url: url,
			data: JSON.stringify(this.answerField.val()),
			contentType: constants.CONTENT_TYPES.APPLICATION_JSON,
			success: function() {
				if (_.result(globals, 'database.id') &&
						globals.mode != constants.MODE_OPERATIONAL &&
						licenses.get().length == 1) {
					var licenseForm = new LicenseForm({
						license: this.license,
						unlinkedDatabases: this.options.unlinkedDatabases
					})
					appDisplay.replaceDialog(licenseForm)
				} else {
					this.trigger('done', this.license.id)
				}
				Backbone.trigger('activate:license', this.license)
			}.bind(this),
			error: function(response) {
				this.formView.error(response)
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.answerField], 'remove')
	}

})

export default LicenseActivation

LicenseActivation.__filename__ = 'admin/licenses/license-activation.js'
